<!-- <nav class="navbar navbar-expand-md" role="navigation">
  <a class="diwima-brand" routerLink="/">{{title}} <span style="color: rgba(0,0,0,.28); font-size: 0.8rem;">v.{{version}} ({{build}})</span></a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
    aria-controls="navbarNavDropdown" aria-expanded="false">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNavDropdown" *ngIf="user$ | async">
    <ul class="navbar-nav">

      <li class="nav-item dropdown">
        <a class="rcweb-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
          {{'AUTH.ACCOUNT' | translate}}
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          <div *ngIf="userData$ | async as userData" style="padding: 0 8px 0 8px">
            <div>{{userData.displayName}}</div>
            <div style="color: grey; font-size: small;">{{userData.email}}</div>
          </div>
          <a class="dropdown-item" (click)="signOutUser()">{{ 'AUTH.BTN_SIGNOUT' | translate }}</a>
        </div>
      </li>
    </ul>
  </div>
</nav> -->

<!-- <div class="container mt-3" *ngIf="selectedContext$ | async as context">
  <a role="button" (click)="deselectContext()">{{'COCKPIT.SELECT_CONTEXT_LABEL' | translate}}</a>
</div> -->
<div class=""><!-- bg-white container mt-3 main-content-->
  <div class=""><!--py-3-->
    <router-outlet></router-outlet>
  </div>
</div>

<div *ngIf="showLoading" class="overlay">
  <div class="overlay__inner">
    <div class="overlay__content">
      <mat-spinner color="accent"></mat-spinner>
    </div>
  </div>
</div>

